
import { isCNSuffix } from '@com/utils/url';
export default {
  props: {
    isBlack: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {
    getLogoIcon: function getLogoIcon() {
      if (isCNSuffix()) {
        return this.isBlack ? 'logo_cn_black' : 'logo_cn_white';
      }
      return this.isBlack ? 'logo_black' : 'logo_white';
    },
    getStyle: function getStyle() {
      return !isCNSuffix() ? {} : { width: '114px' };
    }
  }
};